module.exports = __webpack_public_path__ + "static/media/bt.dccd3c32.svg";